module.exports = __webpack_public_path__ + "static/media/logo_Fundacion.641d7da0.png";